var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.166 5.882.792-2.093h3.507V0H.485v23.98h23.98v-3.789h-3.337l-1.244-1.47-1.245 1.413H9.251v-7.522H6.14l3.902-8.766h3.789l.905 1.98v-1.98h4.694l.735 2.036zm-2.601 1.414v-.848l.34.848 1.583 4.185h1.47l1.584-4.185.283-.848v4.977h1.64V5.034H21.75l-1.244 3.223-.34.905-.339-.905-1.244-3.223h-2.715v6.334h1.697V7.296zm-3.507 4.072h1.867l-2.828-6.39H10.89l-2.828 6.39H9.93l.51-1.244h3.11l.51 1.244zm-2.375-4.185.34-.792.338.792.68 1.64h-1.98l.622-1.64zm-1.131 5.43v6.39h5.316V17.59h-3.733v-1.13h3.62V15.1h-3.62V13.97h3.733v-1.358h-5.316zm11.311 6.277h2.093l-2.998-3.167 2.998-3.167h-2.093l-1.923 2.092-1.923-2.092h-2.149l2.998 3.224-2.998 3.167h2.036l1.923-2.093 2.036 2.036zm.792-3.11 1.81 1.866V13.97l-1.81 1.81z",
    fill: "#006FCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.484)",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAmex);
export default __webpack_public_path__ + "static/media/Icons_Amex.44ea95a61c3aa8072cea7efcbeeefcf2.svg";
export { ForwardRef as ReactComponent };